import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll position to the top whenever the route changes.
 *
 * React Router preserves scroll position by default — that's confusing
 * when a visitor clicks "Open FlipCost" from MyPlanCost and lands halfway
 * down the FlipCost landing because they were halfway down MyPlanCost.
 *
 * Usage: drop `<ScrollToTop />` once inside <BrowserRouter>. Honours
 * in-page hash anchors (`/pricing#notify`) by skipping the reset when
 * one is present, so anchor links still work.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    // `instant` (vs "smooth") because the user just navigated — they
    // expect the next page to start fresh, not animate.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
